module.exports = __webpack_public_path__ + "img/4550887.svg";